import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    LOADING: false,
    SELECT_TRANSFER:{}
  },
  mutations: {
    showLoading(state) {
      state.LOADING = true
    },
    hideLoading(state) {
      state.LOADING = false
    },
    changeSelectTransfer(state,data) {
      state.SELECT_TRANSFER = data
    },
    initSelectTransfer(state) {
      state.SELECT_TRANSFER = {};
    }
  },
  getters: {//对应方法 用来获取属性的状态
    getSelectTransfer(state) {
      return state.SELECT_TRANSFER;
    }
  },
  actions: {//应用 mutation
  },

})